
import { ref, onMounted } from 'vue';
import ModalMessage from '@/components/ModalMessage.vue';
import { Modal } from '@/interfaces/Modal';

export default {
  components: {
    ModalMessage,
  },
  setup() {
    const gebruikersnaam = ref<string>('');
    const modal = ref<Modal>({ show: false, title: 'Wachtwoord vergeten', msg: '' });

    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('user')) {
        gebruikersnaam.value = urlParams.get('user') || '';
      }
    });

    const submitForm = async () => {
      try {
        const response = await fetch('/umbraco/api/member/postforgotpassword', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userName: gebruikersnaam.value }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          if (response.status === 400) {
            const { errors } = errorData;
            modal.value.msg = Object.values(errors).flat().join('<br>');
          } else {
            modal.value.msg = 'Er is iets misgegaan neem svp contact op met de klantenservice.';
          }
          modal.value.show = true;
          return;
        }

        modal.value.msg = 'We hebben je een bericht gestuurd waarmee je het wachtwoord opnieuw kunt instellen. Controleer je e-mail.';
        modal.value.show = true;
      } catch (error) {
        modal.value.msg = 'De gebruikersnaam is niet bekend of gebruiker is nog niet geactiveerd. Neem svp contact op met de klantenservice.';
        modal.value.show = true;
      }
    };

    return {
      gebruikersnaam,
      modal,
      submitForm,
    };
  },
};
